export default __webpack_public_path__ + "static/girl head-1b062a2a9ff4b041dba41d282a7298c6.png";